$(function () {
    // Reference the auto-generated proxy for the hub.
    if (!($.connection)) {
        return
    }

    var app = $.connection.remindersHub;

    if (!app) {
        return;
    }

    $.connection.remindersHub.logging = true;

    app.client.updateReminders = function (ev) {

        var id = "";
        var siteName = "";
        var startTime = "";
        var eventName = "";
        var description = "";
        var url = window.location.protocol + "//" + window.location.host;

        $.each(JSON.parse(ev), function (key, value) {

            if (key === "Id") {
                id = value;
            }

            if (key === "SiteName") {
                siteName = value;
            }

            if (key === "StartTime") {
                startTime = new Date(value);
            }

            if (key === "EventName") {
                eventName = value;
            }

            if (key === "Description") {
                description = value;
            }
        });

        var modalId = "eventnofication_" + id;

        var notification = "  <div class=\"modal fade\" id=\"" + modalId + "\" role=\"dialog\"> " +
            "    <div class=\"modal-dialog\"> " +
            "      <div class=\"modal-content\"> " +
            "        <div class=\"modal-header\"> " +
            "          <h4 class=\"modal-title\">Event Reminder</h4> " +
            "          <button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button> " +
            "        </div> " +
            "        <div class=\"modal-body\"> " +
            "          <p>Event: " + eventName + " at <strong>" + siteName + "</strong><br> " +
            "          Begins at: " + startTime.toLocaleTimeString() + "<br><br> " +
                       description + "</p>" +
            "        </div> " +
            "        <div class=\"modal-footer\"> " +
            "          <div class=\"btn-group btn-group-sm mr-2\" role=\"group\">" +
            "           <button type=\"button\" class=\"btn btn-secondary reminder-response\" data-url=\"" + url + "/Events/Snooze/\" data-event-id=\"" + id + "\">" +
            "           <span class=\"fas fa-clock\"></span>&nbsp;Snooze 5 minutes</button>" +
            "           <button type=\"button\" class=\"btn btn-primary reminder-response\" data-url=\"" + url + "/Events/Dismiss/\" data-event-id=\"" + id + "\">" +
            "           <span class=\"fas fa-times\"></span >&nbsp;Dismiss</button>" +
            "          </div>" +
            "        </div> " +
            "      </div> " +
            "    </div> " +
            " </div>";

        $('[role="main"]').append(notification);

        $("#" + modalId).modal('show'); 

        $('.reminder-response').click(function (e) {
            e.preventDefault();

            var button = $(this);
            var buttons = button.closest('.btn-group').find('.reminder-response');

            var url = button.data('url').trim();
            buttons.attr('disabled', true);

            $.ajax({
                url: url,
                method: 'POST',
                dataType: 'json',
                data: {
                    id: button.data('event-id')
                },
                success: function (response) {

                    if (response.httpCode === 200) {
                        button.closest('.modal').modal('hide');
                    }
                    buttons.removeAttr('disabled');
                }
            });
        });
    }

    // Start the connection.
    $.connection.hub.start().done(function () {
    });
});